import React from "react";
import { Eye, Target, Compass, Award, Sparkles, ChevronRight } from "lucide-react";
import "./Vision.css";

const Vision = () => {
  return (
    <section className="vision">
      <div className="vision-container">
        {/* Background Decorations */}
        <div className="vision-decoration"></div>
        <div className="vision-decoration-2"></div>

        {/* Badge */}
        <div className="vision-badge">
          <Sparkles size={14} className="vision-badge-icon" />
          <span>Our Vision</span>
        </div>

        {/* Main Content */}
        <div className="vision-content">
          <div className="vision-icon-wrapper">
            <Eye size={32} />
          </div>
          
          <h2>
            To become Gujarat's most trusted and preferred <span>cab service</span>
          </h2>
          
          <div className="vision-divider"></div>
          
          <p className="vision-description">
            Known for reliability, comfort, and customer-centered travel experiences.
          </p>

          {/* Vision Points */}
          <div className="vision-points">
            <div className="vision-point">
              <div className="vision-point-icon">
                <Target size={16} />
              </div>
              <div className="vision-point-content">
                <h4>Reliability</h4>
                <p>On-time service you can count on</p>
              </div>
            </div>
            <div className="vision-point">
              <div className="vision-point-icon">
                <Compass size={16} />
              </div>
              <div className="vision-point-content">
                <h4>Comfort</h4>
                <p>Clean, comfortable vehicles</p>
              </div>
            </div>
            <div className="vision-point">
              <div className="vision-point-icon">
                <Award size={16} />
              </div>
              <div className="vision-point-content">
                <h4>Customer-Centered</h4>
                <p>Your satisfaction is our priority</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision;